<template>
    <div class="card">
        <div class="card__title">
            <h5>Empresas y roles</h5>
            <div class="card__controls">
                <button class="btn-success" type="button" @click="agregar"><i class="fa fa-plus"></i></button>
            </div>
        </div>
        <div class="card__content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Roles</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(val, index) in modelValue" :key="index">
                                    <td>
                                        <div class="form-field select2">
                                            <div class="select2-field">
                                                <v-select @input="inputEmpresa(index)" :options="empresas" label="nombre_comercial" placeholder="Seleccione..." id="empresas" v-model="val.selectedEmpresa"></v-select>
                                                <label for="empresas">Empresas</label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-field select2">
                                            <div class="select2-field">
                                                <v-select @input="inputRoles" label="descripcion" :options="val.roles" multiple id="roles" placeholder="Seleccione..." v-model="val.selectedRoles"></v-select>
                                                <label for="roles">Roles</label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <button class="btn-danger btn--text" type="button" @click="eliminar(index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr v-show="modelValue.length === 0">
                                    <td colspan="3">
                                        <strong>No se ha agregado filas.</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        empresasUsuario : {
            type : Array,
            required : true
        }
    },
    data : function () {
        return {
            empresas : [],
            roles : this.value,
            modelValue : [],
            url : url,
            cargaInicial : true
        }
    },
    methods : {
        agregar : function () {
            this.modelValue.push({
                roles : [],
                selectedRoles : [],
                selectedEmpresa : null
            });
        },
        existeRol : function (roles, id) {
            let existe = false;
            for (let i = 0; i < roles.length; i++)
                if (roles[i].id === id)
                    return true;
            return existe;
        },
        inputEmpresa : function (index) {
            let selectedEmpresa = this.modelValue[index].selectedEmpresa;
            if (selectedEmpresa !== undefined && selectedEmpresa !== null) {
                this.modelValue[index].selectedRoles = [];
                this.modelValue[index].roles = [];
                let that = this;
                axios.get(this.url + '/roles/' + selectedEmpresa.id + '/lista').then(function (response) {
                    that.modelValue[index].roles = response.data;
                    for (let i = 0; i < that.roles.length; i++)
                        for(let j = 0; j < that.modelValue[index].roles.length; j++)
                            if (that.modelValue[index].roles[j].id === that.roles[i] && !that.existeRol(that.modelValue[index].selectedRoles, that.roles[i]))
                            {
                                that.modelValue[index].selectedRoles.push(that.modelValue[index].roles[j]);
                                break;
                            }
                    if (index === that.empresasUsuario.length - 1)
                        that.cargaInicial = false;
                });
            }
            else 
            {
                this.modelValue[index].selectedRoles = [];
                this.modelValue[index].roles = [];
            }
        },
        inputRoles : function () {
            if (!this.cargaInicial) {
                let roles = [];
                for (let i = 0; i < this.modelValue.length; i++)
                    roles = roles.concat(this.modelValue[i].selectedRoles);
                let idRoles = [];
                for(let i = 0; i < roles.length; i++)
                    idRoles.push(roles[i].id);
                this.roles = idRoles;
                this.$emit('input', this.roles);
            }
        },
        cargarDatosFormulario : function () {
            let that = this;
            axios.get(this.url + '/usuarios/administrar/datos').then(function (response) {
                that.empresas = response.data.empresas;
                for (let i = 0; i < that.empresasUsuario.length; i++)
                {
                    let row = {
                        selectedEmpresa : that.empresasUsuario[i],
                        roles : [],
                        selectedRoles : []
                    };
                    let index = that.modelValue.push(row) - 1;
                    that.inputEmpresa(index);
                }
            });
        },
        eliminar : function (index) {
            let that = this;
            swal({
                title: '¿Desea eliminar esta fila?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Eliminar fila',
                cancelButtonText : 'No'
            }).then((result) => {
                if (result.value)
                {
                    that.modelValue.splice(index, 1);  
                    that.inputRoles()
                }
            });
        },
        cargarEmpresaSeleccionada : function (id) {

        }
    },
    mounted : function () {
        this.cargarDatosFormulario();
    },
    watch : {
        value : function (value) {
            this.roles = value;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/usuarios/TablaUsuarioEmpresa.vue